import type { Match } from '@uefadigital/panenka';
import { PkIdentifier } from '@uefadigital/panenka-react';
import { memo, useMemo } from 'react';

import { hydrateWithTranslations } from '@services/TranslatorService';
import WinnerAnimation from '@shared/LottieAnimation';
import TeamBadge from '@shared/TeamBadge';
import { useTranslateFn } from '@shared/Translate';
import { matchWinner } from '@utilities/live';

import * as styles from './styles.module.scss';

export const Winner = ({ match, confettiUrl }: { match?: Match; confettiUrl: string }) => {
  const t = useTranslateFn();

  const competitionName = useMemo(() => hydrateWithTranslations(match?.competition)?.name, [match?.competition]);
  const winnerTeam = useMemo(() => hydrateWithTranslations(matchWinner(match)?.team), [match]);

  return (
    <div className={styles.winner}>
      <div className={styles.congratulationsLabel}>{t('congratulations')}</div>
      {!!confettiUrl && <WinnerAnimation animationPath={confettiUrl} className={styles.animationOverlay} />}
      <div className={styles.wrapperLabel}>
        <PkIdentifier className='pk-py--xs'>
          <span slot='prefix'>
            <TeamBadge team={winnerTeam} size={48} />
          </span>
          <span slot='primary'>{winnerTeam?.displayName}</span>
        </PkIdentifier>
      </div>
      <div className={styles.label}>{t('winner_of_comp', { replace: competitionName })}</div>
    </div>
  );
};
export default memo(Winner);
